import { DEFAULT_CHAIN } from '@/shared/config/chain.ts'
import { useBlockNumber, useWatchBlock } from '@lair-finance/wagmi'
import { useLogoutOnWalletDisconnect } from '@/domains/auth/effects/useLogoutOnWalletDisconnect.ts'
import { useResetAuthOnAccountChange } from '@/domains/auth/effects/useResetAuthOnAccountChange.ts'

export function GlobalHooks() {
  useWatchBlock({ chainId: DEFAULT_CHAIN.id, enabled: true })
  useBlockNumber({
    chainId: DEFAULT_CHAIN.id,
    watch: true,
  })
  useLogoutOnWalletDisconnect()
  useResetAuthOnAccountChange()

  return null
}
